import { initSingleModule } from '../initModules';

const DROPDOWN_DISABLED_CLASS = 'dropdown--disabled';
const DROPDOWN_PLACEHOLDER_CLASS = 'js-select-native-placeholder';
const DROPDOWN_PLACEHOLDER_SELECTOR = `.${DROPDOWN_PLACEHOLDER_CLASS}`;
const LINK_INACTIVE_CLASS = 'bfv-wam__link--inactive';
const LINK_TARGET_SELECT_CLASS = 'js-link-target';
const LINK_TARGET_SELECT_SELECTOR = `.${LINK_TARGET_SELECT_CLASS}`;

class BfvWam {
  constructor(options = {}) {
    this.$root = options.element;
    this.$dropdowns = Array.prototype.slice.call(this.$root.querySelectorAll('.js-dropdowns > .dropdown'));
    this.$selects = Array.prototype.slice.call(this.$root.querySelectorAll('.js-dropdowns > .dropdown > select'));
    this.$linkSelect = this.$root.querySelector(LINK_TARGET_SELECT_SELECTOR);
    this.$link = this.$root.querySelector('.js-link');
    this.data = null;
  }

  init() {
    this.bindEvents();
    this.recursiveLoadDropdownData();
  }

  recursiveLoadDropdownData() {
    this.prevSelectedCount = this.selectedCount;
    this.selectedCount = this.$selects.filter(select => !!select.value).length;

    const allDropdownDataLoaded =
    this.selectedCount === this.$selects.length ||
    this.prevSelectedCount >= this.selectedCount;

    if (allDropdownDataLoaded) {
      return;
    }

    this.loadData().then(() => this.recursiveLoadDropdownData());
  }

  bindEvents() {
    this.$selects.forEach(($select) => {

      if (!$select.classList.contains(LINK_TARGET_SELECT_CLASS)) {
        $select.addEventListener('change', () => {
          this.loadData();
        });
      } else if ($select.classList.contains(LINK_TARGET_SELECT_CLASS)) {
        $select.addEventListener('change', () => {
          this.toggleLinkActivity();
        });
      }
    });

    this.$link.addEventListener('click', (event) => {
      if (this.$link.getAttribute('href') === '#') {
        event.preventDefault();
      }
    });
  }

  toggleLinkActivity() {
    const $selectedOption = this.$linkSelect.options[this.$linkSelect.selectedIndex];

    if (!$selectedOption.classList.contains(DROPDOWN_PLACEHOLDER_CLASS)) {
      this.$link.classList.remove(LINK_INACTIVE_CLASS);
      this.$link.setAttribute('href', $selectedOption.value);
    } else {
      this.$link.classList.add(LINK_INACTIVE_CLASS);
      this.$link.setAttribute('href', '#');
    }
  }

  getApiRouteParams() {
    const getParams = [];
    let apiCallRoute = this.$root.getAttribute('data-api-route');

    this.$selects.forEach(($select) => {

      const $selectedOption = $select.options[$select.selectedIndex];
      const key = $select.getAttribute('name');
      const value = $select.value;
      if (key && value && !$selectedOption.classList.contains(DROPDOWN_PLACEHOLDER_CLASS)) {
        getParams.push(`${key}=${value}`);
      }
    });

    if (getParams.length) {
      apiCallRoute += `?${getParams.join('&')}`;
    }

    return apiCallRoute;
  }

  updateDropdowns() {
    this.$dropdowns.forEach(($dropdown) => {
      const $select = $dropdown.querySelector('select');
      const selectName = $select.getAttribute('name');
      const selectData = this.data[selectName];
      const $placeholder = $select.querySelector(DROPDOWN_PLACEHOLDER_SELECTOR).cloneNode(true);

      // Delete all Child-Nodes and readd placeholder
      $select.innerHTML = ''; // Remove all option-Tags
      $select.insertAdjacentElement('beforeend', $placeholder);

      // Update select-Tag if data is available
      if (selectData) {
        $placeholder.selected = false;
        $placeholder.disabled = false;
        $select.disabled = false;
        $select.parentNode.classList.remove(DROPDOWN_DISABLED_CLASS);

        selectData.forEach((optionData) => {
          const $optionTag = document.createElement('option');
          $optionTag.innerText = optionData.label;
          $optionTag.value = optionData.url || optionData.key;

          if (optionData.selected) {
            $optionTag.selected = true;
          }

          $select.insertAdjacentElement('beforeend', $optionTag);
        });

        initSingleModule({ element: $dropdown, name: 'BfvDropdown' });
      } else {
        $placeholder.selected = true;
        $placeholder.disabled = true;
        $select.disabled = true;
        $select.parentNode.classList.add(DROPDOWN_DISABLED_CLASS);
      }
    });

    this.toggleLinkActivity();
  }

  loadData() {
    return window.divae.restApi
      .loadData(this.getApiRouteParams())
      .then((_response) => {
        this.prevData = this.data;
        this.data = _response;
        this.updateDropdowns();
      });
  }
}

export default BfvWam;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvWam/index.js